import React from 'react'

interface LoadingProps {
  text?: string
}

export const Loading: React.FC<LoadingProps> = ({ text = 'Cargando...' }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600"></div>
      <p className="mt-4 text-sm text-gray-600">{text}</p>
    </div>
  )
}
